var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgRightArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 25,
  viewBox: "0 0 24 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.512 12.7858L7.92308 6.46688L8.65154 5.77149L16 12.7858L8.65154 19.7715L7.92308 19.0756L14.512 12.7858Z",
  fill: "#4585FF"
})));
export default SvgRightArrow;